module.exports = __webpack_public_path__ + "img/close.bfdc7fba.svg";